import { Badge, Box, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { NavLink } from 'react-router-dom';
import { VOICE_CALL_RESULTS } from '../../../../common/enums/enums';

const CallResultCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const badgeColor = getEnumColor(VOICE_CALL_RESULTS, rowData.callResult);
    const badgeLabel = getEnumLabel(VOICE_CALL_RESULTS, rowData.callResult);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: '16px',
            }}>
            <Badge
                size={'sm'}
                color={badgeColor}>
                {badgeLabel}
            </Badge>
        </Box>
    );
};

const CallResultColumn = () => ({
    accessorKey: 'callResult',
    header: 'Call Result',
    size: 1,
    minSize: 120,
    Cell: ({ cell }) => <CallResultCell cell={cell} />,
});
export default CallResultColumn;
